import React from 'react';
import { Checkbox } from 'primereact/checkbox';
import { Reservation } from '../../../types/reservation';
import { ExternalUserShort } from '../../../types/externalUser';
import { ReservationFormFieldProps } from '../types';

interface Props extends Pick<ReservationFormFieldProps, 'form' | 'setFormFields'> {
  user: ExternalUserShort;
  resource: Reservation | undefined;
  hasStarted: boolean;
  /** True while the user registers attendance: shows a checkbox instead of the saved attendance. */
  isEditingAttendance: boolean;
}

/** Whether one client came to a reservation that has started. */
export const UserAttendance = ({ user, resource, hasStarted, isEditingAttendance, form, setFormFields }: Props) => {
  if (!hasStarted) return null;
  if (!isEditingAttendance) {
    if (resource?.confirmedExternalUsers?.find((u) => u.id === user.id)?.attendance !== undefined) {
      return (
        <span className='user-attendance'>
          {resource?.confirmedExternalUsers?.find((u) => u.id === user.id)?.attendance ? (
            <>
              <i className='pi pi-user-plus' /> Asistió
            </>
          ) : (
            <>
              <i className='pi pi-user-minus' /> No asistió
            </>
          )}
        </span>
      );
    }
    return null;
  }

  const currentAttendance = form?.attendanceData?.[user.id] ?? false;

  return (
    <div className='attendance-checkbox'>
      <Checkbox
        checked={currentAttendance}
        onChange={(e) => {
          setFormFields({
            attendanceData: {
              ...(form?.attendanceData ?? {}),
              [user.id]: !!e.checked,
            },
          });
        }}
      />
      <span>{currentAttendance ? 'Asistió' : 'No asistió'}</span>
    </div>
  );
};
